<template>
  <div>
    <Row>
      <Form ref="querySysConfigForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('common.sys-config.name.label')" prop="name">
            <Input v-model="query.name" :placeholder="$t('common.sys-config.name.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('common.sys-config.sign.label')" prop="sign">
            <Input v-model="query.sign" :placeholder="$t('common.sys-config.sign.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('common.sys-config.type.label')" prop="type">
        <Select v-model="query.type" clearable filterable :placeholder="$t('common.sys-config.type.holder')">
          <Option v-for="item in $t('common.sys-config.type.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openSysConfigDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="sysConfigTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
<!--        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.sysConfigTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>-->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="sysConfigDrawer" :title="this.$t('drawer.title')[sysConfigDrawer.type]" :visible.sync="sysConfigDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <sysConfig-form ref="sysConfigForm"/>
        <div class="right-drawer__footer" v-if="sysConfigDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="sysConfigDrawer.submiting">{{ sysConfigDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="sysConfigDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import SysConfigForm from '@/views/common/sys-config/components/Form.vue';
Vue.component('sysConfig-form', SysConfigForm);

export default {
  name: 'aip-common-sysConfig-index',
  mixins:[mixin],
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      sysConfigDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.common.SysConfig.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openSysConfigDrawer(sysConfig){
      this.sysConfigDrawer.visible = true
      this.sysConfigDrawer.type = sysConfig ? sysConfig.type : 'add'
      this.$nextTick(()=>{
          if(sysConfig){
              this.$refs['sysConfigForm'].getSysConfig(sysConfig.id,sysConfig.type)
          }else{
            this.$refs['sysConfigForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.sysConfigDrawer.submiting = true;
        this.$refs.sysConfigForm.handleSubmit(
          data=>{
            this.sysConfigDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.sysConfigDrawer.visible=false, 1000);
          },
          ()=>{
            this.sysConfigDrawer.submiting = false;
          }
        )
    },
    deleteSysConfig(id){
      api.common.SysConfig.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.common.SysConfig.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          /*{key: 'id', width: 60, fixed:'left',type:'selection'},*/

          {key: 'name', align:'center',minWidth: 150,fixed:'left', title:  this.$t('common.sys-config.name.label')},
          {key: 'sign', align:'center',minWidth: 150, title:  this.$t('common.sys-config.sign.label')},
          {key: 'content', align:'center',minWidth: 150, title:  this.$t('common.sys-config.content.label')},
          {
            key: 'type',
            align: 'center',
            width: 120,

            column:'type',
            filters: this.$t('common.sys-config.type.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.type = value
              this.handleSearch();
            },
            title: this.$t('common.sys-config.type.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.type==t.value).label}</div>
            }
          },
          {key: 'remark', align:'center',minWidth: 200, title:  this.$t('common.sys-config.remark.label')},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 180,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openSysConfigDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openSysConfigDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteSysConfig(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
